/* === BEGIN imported: modalPages/airportPickupPerks.jsx (verbatim from plugin) === */
import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {POLICY_CONSTANTS} from "@/constants/booking";
import {
    flightDelayIcon,
    infinityIcon,
    perkReliableIcon,
    perkHoldFundsIcon,
    perkFlatRateIcon,
    perkChildSeatsIcon,
    perkCancellationIcon,
    perkLuggageIcon,
    playButton,
    arrowLongDown,
} from "@img/index.js";

export function AirportPickupPerks(props) {
    const backStep = props.previousStep || "policiesListing";

    // Renders inside the gated modal AND (via AirportPerksModal) possibly outside
    // it. Show the real windows only when policies are loaded; otherwise a
    // non-numeric line so we never display a 0/guessed value off-modal.
    const cancellationPerkText = POLICY_CONSTANTS.LOADED
        ? `Free cancellation up to ${POLICY_CONSTANTS.FREE_CANCELLATION_HOURS} hrs & free changes up to ${POLICY_CONSTANTS.EDITABLE_HOURS_BEFORE_PICKUP} hrs before pickup`
        : "Free cancellation & changes before pickup";

    return (
        <>
            {!props.hideHeader && (
                <ModalHeader
                    title=""
                    extraClasses="less-space"
                    totalSteps={0}
                    cancelButton={false}
                    cancelButtonType="icon"
                    backStep={backStep}
                    showBackButton={true}
                    setStep={props.setStep}
                    closeModal={props.closeModal}
                />
            )}

            <div className="hopn-airport-perks modalPages-spacing pb-8">
                <h3>Exclusive Airport Pickup Perks</h3>

                <div className="hopn-perks-highlight">
                    <h5>Flight Delayed? No Problem:</h5>
                    <div className="hopn-perks-highlight-item">
                        <img src={flightDelayIcon} alt="Flight Delay"/>
                        <span>Hop'n tracks your flight and adjusts your pickup time automatically. Whether it's a flight delay or baggage hold-up, we've got you covered. Simply choose "By flight arrival" and let your captain ensure a smooth pickup experience</span>
                    </div>
                    <div className="hopn-perks-highlight-item">
                        <img src={infinityIcon} alt="Unlimited Wait"/>
                        <span>Lost baggage? Customs or immigration delays? No worries—your driver will wait as long as needed</span>
                    </div>
                </div>

                <ul className="hopn-perks-grid">
                    <li>
                        <span><img src={perkReliableIcon} alt="Guaranteed"/></span>
                        Guaranteed 20+ years of reliable pickup
                    </li>
                    <li>
                        <span><img src={perkHoldFundsIcon} alt="Hold Funds"/></span>
                        We Hold funds and charge after drop-off
                    </li>
                    <li>
                        <span><img src={perkFlatRateIcon} alt="Flat Rate"/></span>
                        Flat Fixed Rate. No surge or per km per minute charges
                    </li>
                    <li>
                        <span><img src={perkChildSeatsIcon} alt="Child Seats"/></span>
                        FREE child car seats
                    </li>
                    <li>
                        <span><img src={perkCancellationIcon} alt="Cancellation"/></span>
                        {cancellationPerkText}
                    </li>
                    <li>
                        <span><img src={perkLuggageIcon} alt="Luggage"/></span>
                        Luggage assistance
                    </li>
                </ul>

                <div className="hopn-perks-exclusive">
                    <h5>hop'n Exclusive Airport Pickup Perks</h5>
                    <ul>
                        <li>Stay Comfortable: Relax in a heated or air-conditioned terminal while your driver picks you up right at the door</li>
                        <li>No Waiting in Line: Skip the queues and the airport chaos with our seamless service</li>
                        <li>Child Car Seats Available: Your family's safety is always our top priority</li>
                    </ul>
                </div>

                <div className="hopn-find-driver-link">
                    <div className="hopn-find-driver-link-inner">
                        <img src={playButton} alt="Play"/>
                        <div className="content">
                            <strong>How do I find my driver at the airport?</strong>
                            <span>Here's a guide on where to proceed</span>
                        </div>
                    </div>
                    <button className="download-button" onClick={()=>props.setStep('findingDriver')}>
                        <img src={arrowLongDown} alt="download"/>
                    </button>
                </div>
            </div>
        </>
    );
}
/* === END imported: modalPages/airportPickupPerks.jsx === */
